<template>
<div class="chapter">
<div class="inner_page">
<p class="margin"></p>
<p class="how_to_title" id="how_to1"><b>HOW TO USE THIS BOOK</b></p>
<p class="how_to">The 250 chronological milestones are easily viewed in the selectable table of contents that follows. Each milestone consists of a synopsis, followed by at least one image that helps to illustrate an aspect of the seminal event, publication, or concept. Occasional text in bold type points the reader to related entries. Additionally, a small “See also” section at the bottom of each entry helps weave entries together in a web of interconnectedness and may help the reader traverse the book in a playful quest for discovery.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// how_to.vue?5a1495da